import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export var TableFooterCornerBase = function () { return (React.createElement(RampWithNameTransform, { rampName: "FooterCornerContainer" },
    React.createElement(RampWithNameTransform, { rampName: "FooterHorizontalWrapperCornerContent" }))); };
